<template>
	<div v-loading.fullscreen.lock="homeLoading" element-loading-text="页面载入……" element-loading-background="#ffffff">
	<div id="appbox" v-show="!homeLoading">
			<div class="top">
			<img src="../../../static/img/jylogo.png" alt="" style="position: absolute;top: 25px;left: 40px;width: 225px;height: 80px;object-fit: contain;" >
			<div class="nav" style="font-size: 24px;font-family: 'Courier New', Courier, monospace;text-shadow: 2px 2px 4px rgba(46,41,41,.6);">
				<div class="nav_box" @click="gocolumn('/Camplist')"  >基地信息</div>
				<div class="nav_box" @click="goCourse(item.id)"  v-for="(item,index) in colCate" v-bind:key="index" >{{ item.title }}</div>
				
				
			</div>
	
		</div>
        	<div class="top_banner">
					<el-carousel ref="carousel" :interval="3000"  height="65vh" @change="checklunbo">
						<!-- :interval="4000" -->
					  <!-- <el-carousel-item v-for="(item, key) in platelist" :key="key" >
					    <h3>
							<div style="position: relative;">
								<img :src="item.thumb"  style="width: 100%;height: 100vh;" alt="" @click="gomodules(item.link)">
								<div class="text" style="position: absolute; left: 60px;top: 100px;font-size: 40px;color: #fff;">银色冰雪</div>
							</div>
							
						</h3>
					  </el-carousel-item> -->
					
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图1.jpg"   alt="" >
						
							
								
							</div>
							
						</h3>
					  </el-carousel-item>
					  <!-- <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图2.jpg"  s alt="" >
								
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图3.jpg"   alt="" >
								
							</div>
							
						</h3>
					  </el-carousel-item>
					  <el-carousel-item  >
					    <h3>
							<div style="position: relative;" @click="gocamp(0)">
								<img src="../../../static/img/图四.jpg"   alt="" >
								
							</div>
							
						</h3>
					  </el-carousel-item> -->
					
					</el-carousel>
				</div>
	
		
		
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox" v-if="screenWidth<785"  :style="screenWidth>785?'':'width:100%;'">
				<div class="column_title">
					推荐研学课程
				</div>
				<div class="column_gomore"  @click="gocolumn('/Courselist')">
					查看更多 >
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Courselist')">
				<img src="../../../static/img/研学课程.jpg" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+36)+'%'">
				<div :class="screenWidth>785?'column2_item':'column2_item'" :style="screenWidth>785?'':'margin-bottom:15px;'"   v-for="(item, key) in lessonlist" :key="key" @click="golesson(item.id)">
					<div class="column2_img">
						<img :src="item.cover" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
                        <div style="color: #777;text-align: start;">
                            {{ item.category }}
                        </div>
						<div class="coures_item_tags">

						<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
							{{tag}}
						</div>
					</div>
					</div>
				</div>
			</div>
		</div>
	
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="column_titlebox" v-if="screenWidth<785" :style="screenWidth>785?'':'width:100%;'">
				<div class="column_title">
					营地基地展示
				</div>
				<div class="column_gomore" @click="gocolumn('/Camplist')">
					查看更多
				</div>
			</div>
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Camplist')">
				<img src="../../../static/img/特色基地营地.jpg" alt="" srcset="">
			</div>
			<div class="homecamp_list" :style="screenWidth>785?'':'width:calc(100% - 20px);'" >
				<div class="camp_swiperbox" v-if="Camplist.length>0" :style="screenWidth>785?'':'max-width:100%;zoom:'+((screenWidth/1180)*100+23)+'%'" >
					<swiper :options="swiperOption" ref="mySwiper" v-if="Camplist.length">
					<!-- 	<div class="" > -->
							<swiper-slide v-for="(item, key) in Camplist" :key="key"  >
								<div class="homecamp_item"   :data-id="item.id">
									<div class="column2_img" style="height: 143px;"  :data-id="item.id">
										<img :src="item.cover"  :data-id="item.id" alt="" srcset="">
									</div>
									<div class="hcamp_title"  :data-id="item.id">
										<div class="item_title" style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;min-height: 48px;"  :data-id="item.id">
											{{item.title}}
										</div>
										<div class="homecamp_msg" style="text-overflow: ellipsis;white-space: normal;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"  :data-id="item.id">
											{{'地址:'+item.province}}-{{ item.city }}-{{ item.area }}
										</div>
									</div>
									<div class="hcamp_button"  :data-id="item.id">
										  <button class="el-button el-button--success el-button--small is-plain" size="small" :data-id="item.id" >查看详情</button>
									</div>
								</div>
							</swiper-slide>
						<!-- </div> -->
						<!-- <div class="swiper-pagination" slot="pagination"></div> -->
					</swiper>
				</div>
				<div class="camp_titleicon" v-if="screenWidth>785" >
					<img src="../../../static/img/营地图标.jpg" alt="" srcset="">
					<div class="camp_regionbox" >
						<div class="camp_regionitem"  v-for="(item, key) in regionlist" :key="key" @click="camptypego(item.id)" >
							{{item.title}}
						</div>
					</div>
				</div>
			</div>
	
		</div>
        	<div class="Home_column2" style="margin-bottom: 40px;">
		
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Courselist')">
				<img src="../../../static/img/职工疗养.png" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+36)+'%'">
				<div :class="screenWidth>785?'column2_item':'column2_item'" :style="screenWidth>785?'':'margin-bottom:15px;'"   v-for="(item, key) in Employee" :key="key" @click="golesson(item.id)">
					<div class="column2_img">
						<img :src="item.cover" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
                         <div style="color: #777;text-align: start;">
                            {{ item.category }}
                        </div>
						<div class="coures_item_tags">
						<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
							{{tag}}
						</div>
					</div>
					</div>
				</div>
                 <div v-if="Employee.length==0" style="margin-left: 20px;">
                    <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251128/d0e8cca4e20fae74b88a3ac53648fdf6.png" alt="">
                    <div>暂无产品</div>
			</div>
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
		
			<div class="column_titleicon"  v-if="screenWidth>785"  @click="gocolumn('/Courselist')">
				<img src="../../../static/img/培训团建.png" alt="" srcset="">
			</div>
			<div class="column2_box" :style="screenWidth>785?'':'width:100%;flex-wrap:wrap;zoom:'+((screenWidth/1180)*100+36)+'%'">
				<div :class="screenWidth>785?'column2_item':'column2_item'" :style="screenWidth>785?'':'margin-bottom:15px;'"   v-for="(item, key) in training" :key="key" @click="golesson(item.id)">
					<div class="column2_img">
						<img :src="item.cover" alt="" srcset="">
					</div>
					<div class="column2_title">
						<div class="item_title">
							{{item.title}}
						</div>
						<div class="coures_item_tags">
						<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
							{{tag}}
						</div>
					</div>
					</div>
				</div>
                  <div v-if="training.length==0" style="margin-left: 20px;">
                    <img src="https://review-1254115215.cos.ap-beijing.myqcloud.com/20251128/d0e8cca4e20fae74b88a3ac53648fdf6.png" alt="">
                    <div>暂无产品</div>
			</div>
			</div>
		</div>
	
		<div :class="tops?'navbar':'navbar-top'" style="top: 68%;"  v-if="screenWidth>785">

			 <div  class="qrShow3 right2" style="top: calc(68% - 30px);"  v-if="showofficialQR">
			 	<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			 </div>
			 
		   
		 
		     <div  class="qrShow right" style="top: calc(68% + 90px);;" v-if="showQR">
				<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		     <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a>
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
	
	</div>
	
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {getsupplierlst,getproductlist,getcolCate, getBanner, getWxLogin, getAclist, getNewslist, getCategory, getCamplist, getActivitylist, getPac, getCourselist, getPc, getNt, getTeacher, getAdvbanner, getPlate,getLinelist,getTraveler,getRegion,getexpert,getbottomnav,getsitelist} from '@/request/api'
import { Loading } from 'element-ui';
// import navTab from '../Navtab/navtab'
let _this=null
export default {
  name: "Home",

  data(){
	  return {
	      
			
			top_search_url:'/Siteall',
			modules:'',
			activeIndex2: '/Home',
			Travelerlist:[],
			platelist:[],
			vTabs:false,
			phoneboxshow:false,
			userInfo: {
			  username: "",
			  education_name: "",
			  role_level: ""
			},
			stitle:'',
			Site_url: 'http://www.wanjiaxiao.net/',
			manage_url:'/',
			vannavshow:false,
		
			        value: '',
			newstypes:[],
			Camplist:[],
			newscategory_id:0,
			logintype:true,
			banner:[
			],
			homeLoading: true,
			newslist:[],
			regionlist:[],
			expertlist:[],
			aclist:[],
			lessonlist:[],
			categorytypes:[],
			linelist:[],
			lessoncategory_id:0,
			pcsetdata:{},
			ntlist:[],
			mentorlist:[],
			mentor_index:'',
			mentorindex:0,
			mentortotal:0,
			advbanner:[],
			bottomnav:[],
			swiperexpert:{
				loop: true,
				slidesPerview:'auto',
				loopedSlides:7,
				autoplay:true,
				freeMode:true,
				width:165, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.goexpert(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
			},
			swiperOption:{
				loop: true,
				slidesPerview:'auto',
				loopedSlides:4,
				autoplay: true,
				width:225, 
				pagination: {
					el: '.swiper-pagination',
					type: 'fraction',
					clickable: true
				},
				on:{
					transitionStart(){ // 开始translate之前触发
						// 如果是第一张
						if(this.activeIndex == 0){
							this.setTranslate(0); // 设置位移为0
						}
					},
					click(e) {
						// 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
						let id = e.target.dataset.id;
						console.log(e.target.dataset)
						_this.gocamp(id)
						// 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
						// _this.goInto(url); // 跳转到详情页
					}
				}
				
			},
			//侧边栏
			 showQR:false,
			  showserviceQR:false,
			  showofficialQR:false,
			tops:false,
			heights:window.innerHeight,
			scrolltop:'',
			//屏幕宽高
			// 屏幕宽度
			screenWidth: window.innerWidth,
			top_bannerWidth:Math.round(window.innerWidth/3.42),
			// 屏幕高度
			screenHeight: window.innerHeight,
            colCate:[],
            Employee:[],
            training:[]
	      }
  },
  created() {
	  _this =this
	  this.getpcset()
	   this.getsitelist()
	   setTimeout(() => {
	   		this.homeLoading = false
	   }, 1000)
  },
  mounted() {
	  const { code,state } = this.$route.query;
	  if(code){
		  console.log(111)
		  this.$router.push({
		    path: '/Login',
		    name: "/Login",
		    params: {
		      code,
			  state,
		    }
		  });
		  return
	  }
	  // 监听屏幕宽度和高度变化
	  // this.top_bannerWidth=window.innerWidth/3.42
	    window.addEventListener('resize', this.handleResize, true)
		this.getcolCate()
        
	//   this.getPlate()
	//   this.getRegion()
	//   this.getexpert()
	//   this.getinnovate()
	//   // this.getnewstypes()
    // this._getbanner() 
	// this.getnewstypes()
	// this._getCamplist()
	// this._getAclist()
	// this.getlessontypes()
	// this.getlinelist()
	// this.getmentor()
	// this.getTraveler()
	// this.getNt()
	// this.getAdvbanner()
	// this.getbottomnav()
	var token = localStorage.getItem('token')||''
	this.token=token
	this.getlessonlist()
    this.getsupplierlst()
    this.getemployee()
    this.gettraining()
  window.addEventListener('scroll', this.scrollToTop)
  		
  },
   destroyed () {
          window.removeEventListener('scroll', this.scrollToTop)
    },
  // 销毁监听
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
        getsupplierlst(){
            	var data={
					organ_id:13,
                    page_index:1,
                    page_size:5,
					organ_id:13
				}
				 getsupplierlst(data).then(res => {
				if (res.data.code == 200) {
					this.Camplist=res.data.data.list
					
				}
				// loading.close();
			})
        },  
    	goCourse(e){
		this.$router.push({
				path: '/Courselist',
				name: '/Courselist',
				query: {
					category_id:e
				}
			});
		},	
    	getcolCate(){
				var data={
					organ_id:13
				}
				getcolCate(data).then(res => {
				if (res.data.code == 200) {
					this.colCate=res.data.data.left
					console.log("基地",this.colCate)
				}
				// loading.close();
			})
		},
    // 保险投保跳转
    insureForm() {
      this.$router.push({
        path: "/InsureForm",
        name: "InsureForm",
        query: {}
      });
    },
	  getsitelist(){
	  		var list=this.Siteoptions
	  		getsitelist().then(res=>{
	  			for(var item of res.data.data){
	  				list.push({
	  					value:'http://www.wanjiaxiao.net/subsite/?region_type='+item.region_type,
	  					label:item.title
	  				})
	  			}
	  			this.Siteoptions=list
	  		})  
	  },
	  vanlinkgo(e){
		  console.log(e)
		  this.$router.push({
		    path: e.link,
		    name: e.link,
		    query: {
		    }
		  }); 
	  },
	  vannavmenushow(){
		this.vannavshow=false  
	  },
	  handleResize() {
		   this.top_bannerWidth = 0;
	    this.screenWidth = window.innerWidth;
		this.top_bannerWidth=window.innerWidth/3.42
		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	    this.screenHeight = window.innerHeight;
	  },
	  manageurl(e){
		  console.log('Site',e)
		  if(e!='/'){
			   window.open(e) 
		  }
		this.manage_url='/'
		  // window.location.href = e;
		  
	  },
	  Siteurl(e){
	  		console.log('Site',e)  
	  		window.location.href = e;
	  },
	  logout(){
	  			  var that=this
	  			  this.$confirm('是否确认退出登录?', '提示', {
	  			  					confirmButtonText: '确定',
	  			  					cancelButtonText: '取消',
	  			  					type: 'warning'
	  			  }).then(() => {
	  						this.$alert("已退出登录", '', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								localStorage.setItem('token', '')
	  								localStorage.setItem('refreshToken', '')
	  								 that.$router.go(0)
	  							}
	  						  });
	  			  }).catch(() => {
	  			  		 
	  			  });
	  },
	  showQRCode(){//显示二维码
	          this.showQR = true
	      },
	      hideQRCode(){//隐藏二维码
	          this.showQR = false
	      },
	      scrollToTop () {
	          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
	          this.scrolltop = scrollTop
	          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
	              this.tops = true
	          } else {
	              this.tops = false
	          }
	      },
	      gotop () {
	          let timer = setInterval(() => {
	              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
	              if (this.scrolltop === 0) {
	                  clearInterval(timer)
	              }
	          }, 15)
	      },
	  getbottomnav(){
		  var data={
			  page_index:1,
			  page_size:15
		  }
		getbottomnav(data).then(res=>{
			this.bottomnav=res.data.data.list
		})  
	  },
	  gobottomnav(type,link){
		  if(type==1){
			  this.$router.push({
			  	path:link
			  });
		  }else if(type==2){
			  window.location.href = link;
		  }
	  },
	  goexpertlist(){
		  this.$router.push({
		  	path:'/expertlist',
		  	name:'/expertlist',
		  	query: {
		  	}
		  });
	  },
	  goexpert(id){
		  this.$router.push({
		  	path:'/expertdetails',
		  	name:'expertdetails',
		  	query: {
		  		id: id
		  	}
		  });
	  },
	  camptypego(id){
		  console.log(id)
		  this.$router.push({
		    path: '/Camplist',
		    name: "/Camplist",
		    query: {
		      region_type: id,
		    }
		  });
	  },
	  getRegion(){
	  			var data={
					page_size:10,
				}
	  			getRegion(data).then(res=>{
	  				var regionlist=[]
					var pagesize=0
					for(var item of res.data.data){
						console.log('item',item)
						if(pagesize<8){
							regionlist.push(item)
							
						}
						pagesize+=1
					}
					this.regionlist=regionlist
	  			})
	  },
	  gocolumn(url){
		  this.$router.push({
		    path: url,
		    name: url,
		    query: {
		    }
		  }); 
	  },
	  gotopsearch(){
		  this.$router.push({
		    path: this.top_search_url,
		    name: this.top_search_url,
		    query: {
		      stitle: this.stitle,
		    }
		  }); 
	  },
	  goTraveler(id){
		 this.$router.push({
		   path: "/travelerdetails",
		   name: "travelerdetails",
		   query: {
		     id: id
		   }
		 }); 
	  },
	  gomentor(){
		  this.$router.push({
		    path: "/mentorlist",
		    name: "/mentorlist",
		  		  query: {
		  		  }
		  });
	  },
	  goTravelerlist(){
		  this.$router.push({
		    path: "/traveler",
		    name: "/traveler",
		  		  query: {
		  		  }
		  });
	  },
	  getTraveler(){
		  var data={
		  	isshow:1,
			page_index:1,
			page_size:3,
			modules:this.modules,
		  }  
		  getTraveler(data).then(res=>{
			  this.Travelerlist=res.data.data.list
		  	// this.platelist=res.data.data
		  })
	  },
	  showofficialQRCode(){
		 this.showofficialQR=true
	  },
	  hideofficialQRCode(){//隐藏二维码
	      this.showofficialQR = false
	  },
	  showserviceQRCode(){
	  			  this.showserviceQR=true
	  },
	  hideserviceQRCode(){//隐藏二维码
	      this.showserviceQR = false
	  },
	  showphonebox(){
		this.phoneboxshow=true  
	  },
	  closephonebox(){
		this.phoneboxshow=false  
	  },
	  goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  this.modules=id
			  this._getbanner()
			  
			  this.getnewstypes()
			  this._getCamplist()
			  this._getAclist()
			  this.getlessontypes()
			  this.getlinelist()
			  this.getmentor()
			  this.getTraveler()
		  },
	  getPlate(){
		var data={
			
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  getlinelist(){
		  var data={
			  page_index: 1,
			  page_size: 4,
			  modules:this.modules,
			  is_pc:1,
		  }
		  getLinelist(data).then(res=>{
		  	console.log(res.data)
		  	this.linelist=res.data.data.list
		  	// this.quicklist=res.data.data.list
		  }).catch(error => {
		  	console.error(error);
		  });
	  },
	  getAdvbanner(){
		var data={
			is_pc:2,
			flag:'A'
		}  
		getAdvbanner(data).then(res=>{
			console.log('getAdvbanner',res)
			this.advbanner=res.data.data
		})
	  },
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  getmentor(){
		  var data={
			  page_index:1,
			  page_size:3,
			  modules:this.modules,
		  }
		  getTeacher(data).then(res=>{
			  this.mentorlist=res.data.data.list
		  })
	  },
	  getNt(){
		getNt().then(res=>{
			this.ntlist=res.data.data
		})  
	  },
	  getpcset(){
		getPc().then(res=>{
			this.pcsetdata=res.data.data
			document.title=res.data.data.title
		})  
	  },
	  golesson(e) {
	    this.$router.push({
	      path: "/CourseDetails",
	      name: "CourseDetails",
	      query: {
	        id: e
	      }
	    });
	  },
	  camptypetab(val){
		// this.lessoncategory_id=val
		this.getlessonlist()
	  },
	  getlessontypes(){
	  			var data={}
	  			getPac(data).then(res=>{
	  				console.log(res.data)
	  				this.categorytypes=res.data.data.cat
	  				// this.periodtypes=res.data.data.res
	  				// this.lessoncategory_id=res.data.data.cat[0].id
	  				this.getlessonlist()
	  			}).catch(error => {
	  			  console.error(error);
	  			});
	  },
	  getlessonlist(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:'2',
	  				page_index: 1,
	  				page_size: 4,
					modules:this.modules,
					organ_id:13
	  			}  
	  			getproductlist(data).then(res=>{
	  				this.lessonlist=res.data.data.list
					// this.homeLoading = false
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
        getemployee(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:'3',
					organ_id:13,
	  				page_index: 1,
	  				page_size: 4,
					
	  			}  
	  			getproductlist(data).then(res=>{
	  				this.Employee=res.data.data.list
					// this.homeLoading = false
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
        gettraining(){
	  			var data={
	  				// type:this.camptype,
	  				category_id:'4',
	  				page_index: 1,
	  				page_size: 4,
					organ_id:13
	  			}  
	  			getproductlist(data).then(res=>{
	  				this.training=res.data.data.list
					// this.homeLoading = false
	  				// this.total=res.data.data.total
	  				// this.quicklist=res.data.data.list
	  			}).catch(error => {
	  				console.error(error);
	  			});
	  },
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  getnewstypes(){
		  var data={}
		  getCategory(data).then(res=>{
				  console.log(res.data)
				  var types=[
					{
					  id:'0',
					  icon:'',
					  title:'综合资讯'
					}
				  ]
				  for(var item of res.data.data){
					  types.push(item)
				  }
				  this.newscategory_id='0'
				  this.newstypes=types
				  this._getNewslist()
			}).catch(error => {
			  console.error(error);
			});
	  },
	  _getNewslist(){
		  var data={
			page_index:1,
			page_size:7,
			category_id:this.newscategory_id,
			modules:this.modules,
		  }
		getNewslist(data).then(res=>{
			console.log(res.data)
			this.newslist=res.data.data.list
		  }).catch(error => {
			  console.error(error);
			});
	  },
	  getexpert(){
		  var data={
			page_index:1,
			page_size:20,
			modules:this.modules,
			type:1,
		  }
		  getexpert(data).then(res=>{
		  				  console.log(res.data)
		  				  this.expertlist=res.data.data.list
						  if(this.expertlist.length<8){
							  this.swiperexpert.autoplay=false
						  }
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  getinnovate(){
	  		  var data={
	  			page_index:1,
	  			page_size:3,
	  			modules:this.modules,
	  			type:2,
	  		  }
	  		  getexpert(data).then(res=>{
	  		  				  console.log(res.data)
	  		  				  this.innovatelist=res.data.data.list
	  						  // if(this.expertlist.length<8){
	  							 //  this.swiperexpert.autoplay=false
	  						  // }
	  		  }).catch(error => {
	  		  				  console.error(error);
	  		  			});
	  },
	  _getCamplist(){
		  var data={
			  page_index:1,
			  page_size:8,
			  modules:this.modules,
		  }
		  getCamplist(data).then(res=>{
				  console.log(res.data)
				  this.Camplist=res.data.data.list
		  }).catch(error => {
		  				  console.error(error);
		  			});
	  },
	  _getAclist(){
		  var data={
			  page_index:1,
			  page_size:3,
			  modules:this.modules,
		  }
		  getAclist(data).then(res=>{
		  			  console.log(res.data)
					  this.aclist=res.data.data.list
		  			  // this.banner=res.data.data
		  }).catch(error => {
				  console.error(error);
			});
	  },
	  _getColumn(){
		  getColumn().then(res=>{
		  			  console.log(res.data)
		  			  // this.banner=res.data.data
		  }).catch(error => {
		  			  console.error(error);
		  			});
	  },
	  _getbanner(){
		  // console.log(22233, getBanner())
			var data={
				is_pc:2,
				modules:this.modules,
			}
		  getBanner(data).then(res=>{
			  console.log(res.data)
			  this.banner=res.data.data
		  }).catch(error => {
			  console.error(error);
			});
	  },
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	gontdetails(e){
		this.$router.push({
		  path: "/Ntdetails",
		  name: "Ntdetails",
		  query: {
		    id: e
		  }
		});
	},
    gonews(e){
		this.$router.push({
		  path: "/NewsDetails",
		  name: "NewsDetails",
		  query: {
		    id: e
		  }
		});
	},
	gocamp(e){
		console.log(e)
		this.$router.push({
		  path: "/CampDetails",
		  name: "CampDetails",
		  query: {
		    id: e,
		  }
		});
	},
	goline(e){
		this.$router.push({
		  path: "/LineDetails",
		  name: "LineDetails",
		  query: {
		    id: e
		  }
		});
	},
	goactivity(e){
		this.$router.push({
		  path: "/Activitydetails",
		  name: "Activitydetails",
		  query: {
		    id: e
		  }
		});
	},
	gomodules(e){
		console.log("link");
		console.log(e);
		if(e){
			window.location.href = e;
			//this.$router.push(e);
		}
	},
  }
};
	
</script>

<style scoped>
.top {
	background-image: url(../../../static/img/topbanner.png);
	background-repeat: no-repeat;
	background-size: cover;
	position: relative;
	width: 100%;
	height: 120px;
}
	.coures_item_tags{
		display: flex;
		/* width: 100%; */
		padding-left: 0px;
        justify-content: flex-start;
		
	}
	.campitem_tag{
		width: 70px;
		height: 30px;
		/* margin: 5px; */
		font-size: 12px;
		line-height: 30px;
		color: #FE7C2B;
    	background-color: #FE7C2B12;
	}
	
	.column_titleicon{
		width: 1180px;
		height: 60px;
	}
	.column_titleicon img{
		width: 100%;
		height: 100%;
	}
	.expert_box{
		border: 1px solid #f4f4f4;
		position: relative;
		box-sizing: border-box;
		overflow: hidden;
		border-top: none;
		padding: 20px 15px 20px;
		/* margin:0px 10px; */
		margin-top: -10px;
		/* margin-left: 12px; */
		z-index: 99;
	}
	.homecamp_item{
		width: 210px;
		height: 310px;
		border-radius: 5px;
		background: #ffffff;
		margin-right: 15px;
	}
	.expert_item{
		width: 150px;
		height: 250px;
		border-radius: 5px;
		background: #f9f9f9;
		margin-right: 15px;
	}
	.expert_img{
		width: 100%;
		height: 202.5px;
		border-radius: 5px 5px 0px 0px;
	}
	.expert_img img{
		width: 100%;
		height: 100%;
		border-radius: 5px 5px 0px 0px;
	}
	.home_banner_text{
		width: 100%;
		    padding: 4px 0;
		    background: rgba(71,86,105,.51);
		    color: #fff;
		    text-align: center;
		    position: absolute;
		    bottom: 0;
		    height: 18px;
		    line-height: 18px;
		    font-size: 14px;
	}
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column1{
		width: 1180px;
		display: flex;
		margin: 0 auto;
		justify-content: space-between;
		margin-top: 50px;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.Home_Notice{
		width: 1140px;
		padding: 0px 20px;
		color: #00c8a9;
		display: flex;
		font-size: 18px;
		align-items: center;
		margin: 0 auto;
		margin-top: 20px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		 
	}
	.Notice_list{
		width: 1100px;
		text-align: left;
		margin-left: 10px;
	}
	::v-deep .Notice_list>.el-carousel>.el-carousel__container>.el-carousel__item{
		    background-color: #ffffff !important;
	}
	.Home_advimgs{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.column_titlebox{
		width: 100%;
		padding: 20px 0px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_title{
		font-size: 22px;
		color: #209696;
	}
	.column_right{
		display: flex;
		align-items: flex-end;
		
	}
	.column_right:first-child {
		 border-left: 0px !important;
	  /* 父元素的第一个子元素的样式 */
	}
	.mentor_type{
		padding: 0px 10px;
		font-size: 16px;
		border-left: 1px solid #606266;
		color:#606266 ;
	}
	.gomore_mentor{
		margin-left: 20px;
		font-size: 14px;
		color:#606266 ;
	}
	.column_gomore{
		text-align: right;
		font-size: 16px;
		color: #C0C4CC;
	}
	.column2_box{
		width: 100%;
	
		display: flex;
		justify-content: space-around;
		align-items: flex-end;
	}
	.homecamp_list{
		width: calc(100% - 20px );
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #f9f9f9;
	}
	.camp_swiperbox{
		display: flex;
		flex: 1;
		max-width: 890px;
		margin-right: 30px;
	}
	.camp_titleicon{
		width: 250px;
		height: 310px;
		border-radius: 5px;
		position: relative;
	}
	.camp_titleicon img{
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}
	.camp_regionbox{
		padding: 40px;
		    padding-top: 90px;
		    position: absolute;
		    top: 0px;
		    left: 0px;
		    width: 170px;
		    height: 180px;
		    overflow: hidden;
		    display: flex;
		    flex-wrap: wrap;
		    justify-content: space-between;
		
	}
	.camp_regionitem{
		font-size: 16px;
		color: #209696;
		    height: 28px;
		    width: 80px;
		/* margin-bottom: 10px; */
	}
	.camp_regionitem:hover{
		color:#00c8a9 !important;
		
	}
	.column_blockimg{
		width: 285px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	
	.product_box{
		width: 1180px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EBEEF5;
		padding: 15px 0px;
		border-radius: 5px;
		/* height: ; */
	}
	.prodduct_item{
		width: 195px;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #EBEEF5;
	}
		
	.prodduct_title{
		padding: 4px 10px;
		border-radius: 10px;
		margin-bottom: 4px;
		font-size: 18px;
		font-weight: 600;
		color: #303133;
	}
	.product_msg{
		font-size: 14px;
		color: #909399;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.mentor_imgs{
		width:100px;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	.mentor_msg2{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
	}
	.Traveler_item{
		padding: 20px;
		width: 340px;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.Traveler_title{
		width: 100%;
		font-size: 18px;
		color: #303133;
		text-align: left;
		margin-bottom: 10px;
	}
	.Traveler_msg{
		width: 100%;
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.prodduct_item{
		
	}
	.column2_item{
		width: 265px;
		/* height: 260px; */
		border-radius: 15px;
		position: relative;
	}
	.column2_item_phone{
		width: 132px;
		height: 130px;
		border-radius: 15px;
		position: relative;
	}
	.camp_rank{
		position: absolute;
		left: 0px;
		top: 0px;
		padding: 4px 8px;
		font-size: 14px;
		border-radius: 10px 0px;
		    background: #fe3113;
		    color: #ffffff;
	}
	.column2_img{
		width: 100%;
		height: 180px;
	}
    .campitem_tag{
        margin-left: 0px;
        margin-right: 5px;
    }
	.column2_img_p{
		width: 100%;
		height: 90px;
	}
	.column2_img img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_img_p img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_title{
		padding: 10px;
		background: #f9f9f9;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.hcamp_title{
		padding: 10px;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.item_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 15px;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
	}
	.item_subtitle{
		font-size: 14px;
		color: #909399;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	}
	.homecamp_msg{
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.hcamp_button{
		display: flex;
		    padding: 0px 10px;
	}
	
	
	.Home_imgs{
		width: 575px;
		
	}
	.newnews_box{
		width: 580px;
	}
	.news_top{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.news_title{
		padding: 15px;
		border-bottom: 2px solid #209696;
		color: #209696;
		font-size: 22px;
		font-weight: 600;
	}
	.news_gomroe{
		padding: 17px 0px;
		text-align: right;
		flex: 1;
		font-size: 16px;
		border-bottom: 1px solid #E4E7ED;
		color: #C0C4CC;
	}
	.newslist{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 0px;
	}
	.news_item{
		text-align: left;
	}

	
	.el-tag--mini{
		font-size: 8px !important;
		    padding: 0 2.8px;
	}
	.mentor{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
		
	}
	.mentor_box{
		width: 1100px;
		display: flex;
		/* justify-content: ; */
		flex-wrap: wrap;
		
		background: #30313336;
	}
	.mentor_msg_box{
		position: absolute;
		width: 180px;
		height: 245px;
		background: #333333c7;
		color: #ffffff;
		top: 0px;
		    left: 0px;
	}
/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
	.mentor_tags{
		padding: 9px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mentor_camp{
		font-size: 14px;
		text-align: left;
		padding: 10px;
		padding-top: 0px;
	}
	.ntmain{
		width: 1000px;
	}
	.nttext:hover{
		color: #00C8A9 !important;
	}
	.ntbox{
		width: 1060px;
		    background: #ffffff;
		    margin: 10px auto;
		    display: flex;
		    align-items: center;
		    padding: 0px 20px;
	}
	.nticon{
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}

	.lessonbox{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.home_titlebox{
		width: 1100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.next_text{
		margin-bottom: 20px;
		font-size: 16px;
	}
	.camplist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.lessonlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actmsgbox{
		width: 320px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.actbutton{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #00C8A9;
	}
	.actbutton2{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #9e9e9e;
	}
	.actbox{
		width: 1100px;
		margin-top: 20px !important;
		margin: 0 auto;
	}
	.campitem{
		width: 340px;
		border-radius: 8px;
			color: #333;
	}
	.lessonitem{
		width: 257px;
		margin-bottom: 10px;
		color: #333;
	}
	.lessonitem:hover{
		color: #00C8A9;
	}
	.campitem:hover{
		color: #00C8A9;
	}
	.lessonimgbox{
		width: 257px;
		height: 177px;
		position: relative;
	}
	.lessonimgbox img{
		width: 100%;
		height: 100%;
	}
	.campimgbox{
		width: 340px;
		height: 168px;
		position: relative;
		
	}
	.actimgbox{
		width: 340px;
		height: 218px;
	}
	.actimgbox img{
		width: 100%;
		height: 100%;
	}
	.actpay{
		font-size: 14px;
		color: brown;
	}
	
	.campimgbox img{
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}
	.campaddress{
		width: 320px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		font-size: 12px;
		font-weight: 600;
		color: #ffffff;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		background: #30313336;
	}
	.camptitle{
		padding: 10px;
		font-size: 18px;
		width: 320px;
		height: 46px;
	
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.lessontitle{
		padding: 10px;
		font-size: 18px;
		width: 237px;
		height: 46px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.imgsbox{
		/* width:1100px; */
		/* margin: 10px auto; */
	}
	.advbanner{
		width:1100px;
		margin: 0px auto;
	}
	.newsimgH{
		width: 210px;
		height: 135px;
		background-color: #333;
	}
	.newsitemH{
		width: 525px;
		padding: 10px;
		border-radius: 8px;
		display: flex;
		/* justify-content: ; */
		
		align-items: center;
		margin-bottom: 10px;
		background: #ffffff;
	}
	.newsitemH:hover{
		color: #00c8a9;
	}
	.newsitembox{
		width: 100%;
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.newsmsgH{
		width: 280px;
		height: 135px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
	.news_bottomH{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.newstitle{
		font-size: 18px;
		
	}
	.campbox{
		width: 1100px;
		margin: 0 auto;
	}
/* 	::v-deep .el-tabs__header{
		margin: 0px !important;
	} */
	.el-tabs__item{
		font-size: 18px;
		/* padding:30px ; */
	}
	::v-deep .el-tabs__item.is-active{
		color: #209696;
	}
/* 	::v-deep .el-tabs__active-bar{
		width: 112px !important;
	} */
/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>

/* 	.top_banner>.el-carousel>.el-carousel__indicators--horizontal{
		bottom: 180px;
	} */

	
	.el-tabs__active-bar{
		background-color: #00c8a9 !important;
	}
	.el-tabs__item{
		padding-left: 20px !important;
	}
	.el-tabs__nav-wrap{
		background: #ffffff;
	}
	
	.newsbox{
		width: 1100px;
		margin: 10px auto;
		display: flex;
	}
	.video{
		width: 50%;
		height: 350px;
		background-color: #333;
		margin-left: 10px;
	}
	.video video{
		width: 100%;
		height: 100%;
	}
	.news_box{
		display: flex;
		min-height: 400px;
		width: 100%;
		/* background: #ffffff; */
	}
	.news_item{
		padding: 10px;
		color:#333;
		width: 95%;
		border-bottom: 1px solid #d3d3d326;
		overflow: hidden;
		   white-space: nowrap;
		   text-overflow: ellipsis;
	}
	.news_item:hover
	{ 
		color:#209696;
	    background-color:#d9f8fa;
	}
	.newslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.newslefticon img{
		width: 100%;
		height: 100%;
	}
	.actslefticon{
		width: 80px;
		height: 350px;
		writing-mode: vertical-lr;
		writing-mode: tb-lr;
		color: #ffffff;
		font-weight: 600;
		background: #3a8ee6;
		font-size: 30px;
		line-height: 80px;
		/* margin-left: 10px; */
		margin-right: 10px;
	}
	.actslefticon img{
		width: 100%;
		height: 100%;
	}
	.news_list{
		/* width: 40%; */
		width: 455px;
		height: 350px;
		/* border-radius: 10px; */
		    box-shadow: 2px -2px 14px 6px #3a8ee626;
			background: #ffffff;
		/* background:; */
	}
	.newsbox .el-carousel--card{
		width: 100%;
	}
	

	
	/* 图片轮播 */
	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 14px;
	    opacity: 0.75;
	    line-height: 150px;
	    margin: 0;
	  }
		
	  .el-carousel__item:nth-child(2n) {
	     background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	     background-color: #d3dce6;
	  }
	  @media only screen and (max-width: 768px){ /* 在小于等于768px的设备上执行该CSS代码 */
	  
	  	.el-tabs__item{
	  		font-size: 16px;
			padding: 0px;
	  	}
	
	  }
	  .nav_box{
		/* width: 25vh; */
	  }
</style>